import {
    RANKING_DEX_USER_LOADING,
    RANKING_DEX_USER_LOADED,
    RANKING_DEX_USER_ERROR,

    RANKING_DEX_ESPECIE_LOADING,
    RANKING_DEX_ESPECIE_LOADED,
    RANKING_DEX_ESPECIE_ERROR

  } from '../../types/dex';

const INITIAL_STATE = {
    loadingRankingU: false,
    loadedRankingU: false,
    errorRankingU: "",
    rankingUser: [], 

    loadingRankingE: false,
    loadedRankingE: false,
    errorRankingE: "",
    rankingEspecie: [],      
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
         
        case RANKING_DEX_ESPECIE_LOADING:
            return {
                ...state,
                loadingRankingE: true,
                loadedRankingE: false,
                rankingEspecie: [], 
                errorRankingE: "",
            };

        case RANKING_DEX_ESPECIE_LOADED:
            return {
                ...state,
                loadingRankingE: false,
                loadedRankingE: true,
                rankingEspecie: action.payload,
                errorRankingE: "",
            };

        case RANKING_DEX_ESPECIE_ERROR:
            return {
                ...state,
                loadingRankingE: false,
                loadedRankingE: false,
                rankingEspecie: [],
                errorRankingE: action.payload,
            };

        case RANKING_DEX_USER_LOADING:
            return {
                ...state,
                loadingRankingU: true,
                loadedRankingU: false,
                rankingUser: [], 
                errorRankingU: "",
            };

        case RANKING_DEX_USER_LOADED:
            return {
                ...state,
                loadingRankingU: false,
                loadedRankingU: true,
                rankingUser: action.payload,
                errorRankingU: "",
            };

        case RANKING_DEX_USER_ERROR:
            return {
                ...state,
                loadingRankingU: false,
                loadedRankingU: false,
                rankingUser: [],
                errorRankingU: action.payload,
            };

        default:
            return state;
    }
}